// src/redux/reducers/configReducer.js

import {
    FETCH_CONFIG_START,
    FETCH_CONFIG_SUCCESS,
    FETCH_CONFIG_FAILURE,
    FETCH_ALL_CONFIGS_START,
    FETCH_ALL_CONFIGS_SUCCESS,
    FETCH_ALL_CONFIGS_FAILURE,
    SAVE_CONFIG_START,
    SAVE_CONFIG_SUCCESS,
    SAVE_CONFIG_FAILURE,
    CONFIG_UPDATE_SUCCESS,
    CONFIG_UPDATE_FAILURE,
    RESET_CONFIG_STATE
  } from '../actions/actionTypes.js';
  
  const initialState = {
    configs: {}, // { configName: configData }
    configNames: [], // List of all config names
    loading: false,
    saving: false,
    error: null,
    pendingUpdates: {}, // track configs with local updates
  };
  
  const configReducer = (state = initialState, action) => {
    switch (action.type) {
      case RESET_CONFIG_STATE:
        return initialState;
     
      case FETCH_CONFIG_START:
      case FETCH_ALL_CONFIGS_START:
        return { ...state, loading: true, error: null };
      
      case FETCH_CONFIG_SUCCESS: {
        console.log('Reducer - FETCH_CONFIG_SUCCESS:', action.payload);
        const { name, data } = action.payload;
        // If there's a pending local update for this config, skip override and clear the flag
        if (state.pendingUpdates[name]) {
          return {
            ...state,
            loading: false,
            pendingUpdates: { ...state.pendingUpdates, [name]: false },
          };
        }
        // Normal fetch: update state from server
        return {
          ...state,
          loading: false,
          configs: { ...state.configs, [name]: data },
        };
      }
      
      case FETCH_ALL_CONFIGS_SUCCESS:
        return {
          ...state,
          loading: false,
          configNames: action.payload,
        };
      
      case FETCH_CONFIG_FAILURE:
      case FETCH_ALL_CONFIGS_FAILURE:
        return { ...state, loading: false, error: action.payload };
      
      case SAVE_CONFIG_START:
        return { ...state, saving: true, error: null };
      
      case SAVE_CONFIG_SUCCESS:
        return {
          ...state,
          saving: false,
          configs: { ...state.configs, [action.payload.name]: action.payload.data },
        };
      
      case SAVE_CONFIG_FAILURE:
        return { ...state, saving: false, error: action.payload };
        
      case CONFIG_UPDATE_SUCCESS: {
        const { name, data } = action.payload;
        return {
          ...state,
          configs: { ...state.configs, [name]: data },
          pendingUpdates: { ...state.pendingUpdates, [name]: true },
        };
      }
    
    case CONFIG_UPDATE_FAILURE:
      return {
        ...state,
        error: action.payload.error,
      };
      
      default:
        return state;
    }
  };
  
  export default configReducer;